export function detectDrag(e: MouseEvent) {
	return new Promise<any>(res => {
		const handleMouseUp = () => {
			// eslint-disable-next-line @typescript-eslint/no-use-before-define
			document.removeEventListener("mousemove", handleMouseMove);
			document.removeEventListener("mouseup", handleMouseUp);
			res(false);
		};
		const timeout = setTimeout(() => {
			handleMouseUp();
		}, 1000);
		const handleMouseMove = moveEvent => {
			if (Math.abs(moveEvent.pageX - e.pageX) > 4 || Math.abs(moveEvent.pageY - e.pageY) > 4) {
				document.removeEventListener("mousemove", handleMouseMove);
				document.removeEventListener("mouseup", handleMouseUp);
				clearTimeout(timeout);
				res({ x: e.pageX, y: e.pageY });
			}
		};

		document.addEventListener("mousemove", handleMouseMove);
		document.addEventListener("mouseup", handleMouseUp);
	});
}
